var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"mathJaxEl",staticClass:"mathJaxEl",domProps:{"innerHTML":_vm._s(_vm.formula)}})
}
var staticRenderFns = []

export { render, staticRenderFns }